import Model from './Model'

export default class Company extends Model
{
    static async all () {
        const { data } = await Http.get(route('api.v1.companies.index'))
        return this.make(data)
    }

    static async search (query) {
        const params = { query }
        const { data } = await Http.get(route('api.v1.companies.index'), { params })
        return this.make(data)
    }
}
